module.exports = __webpack_public_path__ + "media/landing/slider-1-17367855.jpg";